/* eslint-disable complexity
   -- supportedLocales and configLocale use switch statements with many cases */
import { loadLanguagePack, updateLocale } from '@americanexpress/one-app-ducks';

export const supportedLocales = (market = '') => {
  switch (market.toLowerCase()) {
    case 'en-us':
      return 'en-US';
    case 'ja-jp':
      return 'ja-JP';
    case 'en-au':
      return 'en-AU';
    case 'en-in':
      return 'en-IN';
    case 'fr-fr':
      return 'fr-FR';
    case 'es-es':
      return 'es-ES';
    case 'es-mx':
      return 'es-MX';
    case 'sv-se':
      return 'sv-SE';
    case 'en-gb':
      return 'en-GB';
    case 'en-ca':
      return 'en-CA';
    case 'fr-ca':
      return 'fr-CA';
    case 'nb-no':
      return 'nb-NO';
    case 'de-de':
      return 'de-DE';
    case 'en-hk':
      return 'en-HK';
    case 'zh-hk':
      return 'zh-HK';
    case 'it-it':
      return 'it-IT';
    case 'en-sg':
      return 'en-SG';
    case 'en-nz':
      return 'en-NZ';
    case 'nl-nl':
      return 'nl-NL';
    case 'de-at':
      return 'de-AT';
    case 'fi-fi':
      return 'fi-FI';
    default:
      return null;
  }
};

const configLocale = (store) => {
  const { dispatch } = store;
  return (nextState, replace, callback) => {
    const [, currentLocale] = nextState.location.pathname.split('/');
    const newLocale = supportedLocales(currentLocale);
    if (newLocale) {
      dispatch(updateLocale(newLocale));
      dispatch(loadLanguagePack('axp-prospect-root', { fallbackLocale: 'en-US' }));
    }
    return callback();
  };
};
export default configLocale;
/* eslint-enable complexity */
